import { loadStripe, Stripe } from '@stripe/stripe-js';

// Initialize Stripe with publishable key from environment
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey && import.meta.env.DEV) {
  console.warn('Missing VITE_STRIPE_PUBLISHABLE_KEY environment variable. Stripe features will be disabled.');
}

// Only load Stripe if we have a valid key
export const stripePromise: Promise<Stripe | null> = stripePublishableKey
  ? loadStripe(stripePublishableKey)
  : Promise.resolve(null);
